import { relationGroupsConstants } from '../../_constants';
import { relationGroupsService } from '../../_services';

export const relationGroupsTableActions = {
    getRelationGroups
};

function getRelationGroups() {
    return dispatch => {
        dispatch(request());
        relationGroupsService.getRelationGroups()
            .then(
                relationGroups => {
                    dispatch(success(relationGroups));
                },
                error => {
                    dispatch(failure(error));
                }
            );
    };

    function request() { return { type: relationGroupsConstants.REQUEST_RELATION_GROUPS} }
    function success(relationGroups) { return { type: relationGroupsConstants.RECEIVE_RELATION_GROUPS, relationGroups } }
    function failure(error) { return { type: relationGroupsConstants.RELATION_GROUPS_ERROR, error } }
}



// WEBPACK FOOTER //
// ./src/_actions/relationGroups/relationGroupsTable.actions.js